<template>
  <div class="SelosVinculados">
    <div class="SelosVinculados_header">
      <div class="row">
        <div class="col-sm-9 col-12">
          <label class="label SelosVinculados_title pl-2">
            Selos vinculados
          </label>
        </div>

        <div class="col-sm-3 col-12">
          <input :id="`busca_selo_vinculador_${_uid}`"
                 v-model="buscaSelosVinculados"
                 v-uppercase
                 class="form-control"
                 name="busca_selo_vinculador"
                 placeholder="Busca selo vinculador"
                 type="text">
        </div>
      </div>
    </div>


    <div v-if="selosVinculados.length > 0 && vinculacoes.length > 0">
      <div v-for="(vinculacao, indexDataVinculacao) in vinculacoes"
           :key="`data_vinculacao_${indexDataVinculacao}`"
           class="BoxVinculacao mt-3 ml-1 mr-1">
        <div class="BoxVinculacao_header ml-0 mr-0 BoxVinculacao_header_color">
          <div class="row mt-1 mb-1 ml-3 mr-3">
            <div class="col-sm-3 col-12 pl-0 pr-0">
              <div class="BoxVinculacao_header_box BoxVinculacao_header_box_selo_vinculador">
                <span class="BoxVinculacao_header_box_text">Selo Vinculador</span>

                <div class="BoxVinculacao_header_box_border_dark_top" />

                <span class="BoxVinculacao_header_box_info">
                  {{ selosVinculados.find(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).seloVinculador.num_selo }}
                </span>
              </div>
            </div>

            <div class="col-sm-2 col-12 pl-0 pr-0">
              <div class="BoxVinculacao_header_box BoxVinculacao_header_box_data_vinculacao">
                <div class="BoxVinculacao_header_box_text">
                  Data/hora vinculação
                </div>

                <div class="BoxVinculacao_header_box_border_dark_top" />

                <span class="BoxVinculacao_header_box_info">
                  {{ selosVinculados.find(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).dataVinculacaoFormatada }}
                </span>
              </div>
            </div>
          
            <div class="col-sm-7 col-12 pl-0 pr-0 d-inline-flex align-items-center justify-content-end">
              <div class="row mr-0">
                <span class="BoxVinculacao_header_font_status">
                  {{ vinculacao.status }} 
                </span>

                <IconSvg v-if="vinculacao.status === 'Vinculação enviada'"
                         icon="done"
                         style="fill: green;"
                         class="icon--sm ml-2" />

                <IconSvg v-else-if="vinculacao.status === 'Revisar vinculação'"
                         icon="alert"
                         style="fill: #8b0000;"
                         class="icon--sm icons--red ml-2" />

                <IconSvg v-else
                         icon="airplane"
                         style="fill: #074f7f;"
                         class="icon--sm ml-2" />
              </div>
            </div>
          </div>
        </div>

        <div class="my-2 px-2">
          <div class="row no-gutters col-12 pl-2 pr-1">
            <div class="col-10">
              <div class="mr-2 BoxVinculacao_detailsBoxInfo">
                <h2 class="BoxVinculacao_detailsBoxInfo_title">
                  Descrição do ato vinculador
                </h2>

                <p class="BoxVinculacao_detailsBoxInfo_text">
                  {{ selosVinculados.find(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).seloVinculador.seloItemOs.ordemServicoItem.custa.ato }}
                </p>
              </div>
            </div>

            <div class="col-2 mt-1 mb-1">
              <button v-if="vinculacao.status === 'Vinculação a ser enviada'"
                      class="btn btn-block btn-sm btn-outline-success"
                      @click="abrirModalEnviarVinculacoesTJ(selosVinculados.find(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).seloVinculador.num_selo, vinculacao.data)">
                Enviar ao TJ
              </button>
            
              <button class="btn btn-block btn-sm btn-outline-primary"
                      @click="editarVinculacao(selosVinculados.find(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).seloVinculador, vinculacao.data)">
                Acessar
              </button>
            </div>
          </div>
        </div>

        <div v-if="vinculacao.openCard"
             class="my-3 px-3">
          <table class="Listagem">
            <tr>
              <th class="Listagem_width_selo_vinculado">
                <span class="BoxVinculacao_detailsBoxInfo_title">
                  {{ selosVinculados.filter(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).length > 1 ? 'Selos vinculados' : 'Selo vinculado' }}
                </span>
              </th>

              <th class="Listagem_width_descricao">
                <span class="BoxVinculacao_detailsBoxInfo_title">
                  {{ selosVinculados.filter(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).length > 1 ? 'Descrição dos atos vinculados' : 'Descrição do ato vinculado' }}
                </span>
              </th>
            </tr>

            <tr v-for="(seloVinculado, indexVinculacao) in selosVinculados.filter(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data)"
                :key="`selos_vinculados_${seloVinculado.seloVinculacao.num_selo}_${indexVinculacao}`"
                class="BoxVinculacao_detailsBoxInfo_line_height"
                :class="{ 'Listagem_border_bottom': (indexVinculacao < selosVinculados.filter(seloVinculado => seloVinculado.data_vinculacao === vinculacao.data).length - 1) }">
              <td class="d-inline-flex">
                {{ seloVinculado.seloVinculacao.num_selo }}
              </td>

              <td>
                {{ seloVinculado.seloVinculacao.seloItemOs.ordemServicoItem.custa.ato }}
              </td>
            </tr>
          </table>
        </div> 

        <div class="mt-2 row no-gutters">
          <button class="BoxVinculacao_openDetails w-100 text-center"
                  @click="vinculacao.openCard = !vinculacao.openCard">
            <svg class="searchCard_openDetails_icon icon--xxs"
                 :class="{ 'BoxVinculacao_rodate_button': vinculacao.openCard }"
                 role="presentation">
              <use :xlink:href="'#' + arrowDown.id" />
            </svg>
          </button>
        </div>
      </div>

      <b-modal v-if="modalEnviarVinculacaoTJ"
               :id="`modalEnvioTJ_${_uid}`"
               :ref="`modalEnvioTJ_${_uid}`"
               modal-class="EnvioTJ"
               body-clas="EnvioTJ_body"
               header-class="EnvioTJ_header"
               :visible="true"
               hide-header
               hide-footer
               centered
               size="md"
               @hide="fecharModalEnviarVinculacoesTJ()">
        <label class="EnvioTJ_titulo mt-1 ml-4 pl-2">
          Gostaria de enviar ao TJ a lista de selos vinculados?
        </label>

        <div class="row no-gutters justify-content-end align-items-center">
          <div class="d-inline-block mt-3 mb-1">
            <button ref="botaoVincularDepois"
                    class="btn btn-sm EnvioTJ_botao-voltar pl-4 pr-4"
                    @click="fecharModalEnviarVinculacoesTJ()">
              Deixar para mais tarde
            </button>
          </div>

          <div class="d-inline-block ml-2 mt-3 mb-1 mr-3">
            <button class="btn btn-sm btn-primary pl-4 pr-4"
                    @click="enviarVinculacoesTJ()">
              Enviar
            </button>
          </div>
        </div>
      </b-modal>
    </div>

    <div v-else>
      <label class="pt-3 pl-3">
        Nenhum selo vinculado no momento.
      </label>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import arrowUp from "@/assets/icons/arrow-up-bold.svg?sprite"
  import arrowDown from "@/assets/icons/arrow-down.svg?sprite"

  /* services */
  import SelosService from "@/services/Registros/SelosService"

  export default {
    name: 'SelosVinculados',
    props: {
      propRegistroId: { type: Number, default: () => null },
      propHabilitacao: { type: Object, default: () =>  null },
      propOpenWindowEditarVinculacao: { type: Object, default: () => null }
    },
    data () {
      return {
        arrowUp,
        arrowDown,

        buscaSelosVinculados: null,

        // lista de selos vinculados
        selosVinculadosArrOriginal: [],
        selosVinculados: [],

        // separamos as datas para o layout de listagem
        vinculacoesArrOriginal: [],
        vinculacoes: [],

        // controla o modal de enviar vinculação pro TJ
        modalEnviarVinculacaoTJ: false,

        // obj de envio pro TJ
        enviarVinculacaoTJ: {
          numSeloVinculador: null,
          dataVinculacao: null
        }
      }
    },
    watch: {
      buscaSelosVinculados (newVal) {
        // Caso o campo esteja em branco, voltamos os arrays originais
        if (!newVal) {
          this.vinculacoes = this.vinculacoesArrOriginal
          this.selosVinculados = this.selosVinculadosArrOriginal
          return
        }

        // Filtramos o selo vinculador
        this.selosVinculados = this.selosVinculadosArrOriginal.filter(seloVinculado => {
          if (seloVinculado.seloVinculador.num_selo.search(newVal) >= 0) {
            return seloVinculado
          }
        })

        // Com base na filtragem acima, filtramos as vinculações
        this.vinculacoes = this.vinculacoesArrOriginal.filter(vinculo => {
          if (this.selosVinculados.find(seloVinculado => seloVinculado.data_vinculacao === vinculo.data)) {
            return vinculo
          }
        })
      }
    },
    async beforeMount () {
      await this.getSelos()

      if (this.propOpenWindowEditarVinculacao) {
        const { numSeloVinculador, dataVinculacao } = this.propOpenWindowEditarVinculacao

        const vinculacao = this.selosVinculadosArrOriginal.find(seloVinculado => {
          const dataVinculacaoSeloVinculado = moment(seloVinculado.data_vinculacao).format('YYYY-MM-DD HH:mm:ss')

          return (seloVinculado.seloVinculador.num_selo === numSeloVinculador && dataVinculacaoSeloVinculado === dataVinculacao)
        })

        if (vinculacao) {
          return this.editarVinculacao(vinculacao.seloVinculador, vinculacao.data_vinculacao)
        }
      }
    },
    methods: {
      async getSelos () {
        if (!this.propRegistroId) {
          this.selosVinculados = []
          return
        }

        loader({ text: 'Buscando selos vinculados...', active: true })

        try {
          const selosVinculados = await SelosService.getSeloVinculadosByRegistroId({ registro_id: this.propRegistroId })

          for (let vinculacao of selosVinculados) {
            // Formatamos as datas
            vinculacao.dataVinculacaoFormatada = moment(vinculacao.data_vinculacao).format('DD/MM/YYYY - HH:mm')
            vinculacao.dataVinculacaoFormatada = vinculacao.dataVinculacaoFormatada.replace(':', 'h')

            // Adicionamos o status
            if (!vinculacao.envio_vinculacao_tj && !vinculacao.erro_vinculacao_tj) {
              vinculacao.status = 'Vinculação a ser enviada'
            } else if (!vinculacao.envio_vinculacao_tj && vinculacao.erro_vinculacao_tj) {
              vinculacao.status = 'Revisar vinculação'
            } else if (vinculacao.envio_vinculacao_tj && vinculacao.data_envio_vinculacao_tj && !vinculacao.erro_vinculacao_tj) {
              vinculacao.status = 'Vinculação enviada'
            }
          }

          // Atualizamos os dados das páginas
          this.selosVinculados = selosVinculados

          // Filtramos as datas das vinculações para mostrar na table
          this.selosVinculados.forEach((vinculo, index) => {
            // Filtramos os selos com a mesma data
            let selosComMesmaData = this.selosVinculados.filter(seloVinculado => seloVinculado.data_vinculacao === vinculo.data_vinculacao)

            // Pegamos os status
            selosComMesmaData = selosComMesmaData.map(seloComMesmaData => seloComMesmaData.status)

            // Tira os status duplicados
            selosComMesmaData = [...new Map(selosComMesmaData.map(item => [item, item])).values()]

            const statusConcluido = selosComMesmaData.find(seloComMesmaData => seloComMesmaData === 'Vinculação enviada')
            const statusAEnviar = selosComMesmaData.find(seloComMesmaData => seloComMesmaData === 'Vinculação a ser enviada')
            const statusRevisar = selosComMesmaData.find(seloComMesmaData => seloComMesmaData === 'Revisar vinculação')

            if (index === 0) {
              this.vinculacoes.push({
                data: vinculo.data_vinculacao,
                status: statusAEnviar ? statusAEnviar : statusRevisar ? statusRevisar : statusConcluido,
                openCard: false
              })
              return
            }

            const ultimoIndexData = this.vinculacoes.length - 1

            if (vinculo.data_vinculacao !== this.vinculacoes[ultimoIndexData].data) {
              this.vinculacoes.push({
                data: vinculo.data_vinculacao,
                status: statusAEnviar ? statusAEnviar : statusRevisar ? statusRevisar : statusConcluido,
                openCard: false
              })
            }
          })

          if (this.propHabilitacao) {
            this.verificarSelosHabilitacao(this.propHabilitacao)
          }

          this.vinculacoesArrOriginal = this.vinculacoes
          this.selosVinculadosArrOriginal = this.selosVinculados
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível encontrar os selos vinculados desse registro'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)
        } finally {
          loader({ text: '', active: false })
        }
      },

      editarVinculacao (seloVinculador, dataVinculacao) {
        this.$emit('editar', { seloVinculador, dataVinculacao })
      },

      async abrirModalEnviarVinculacoesTJ (numSeloVinculador, dataVinculacao) {
        this.modalEnviarVinculacaoTJ = true
        this.enviarVinculacaoTJ.numSeloVinculador = numSeloVinculador
        this.enviarVinculacaoTJ.dataVinculacao = dataVinculacao

        setTimeout(() => {
          if (this.$refs['botaoVincularDepois']) {
            this.$refs['botaoVincularDepois'].focus()
          }
        }, 100)
      },

      async fecharModalEnviarVinculacoesTJ () {
        this.modalEnviarVinculacaoTJ = false
        this.enviarVinculacaoTJ.numSeloVinculador = null
        this.enviarVinculacaoTJ.dataVinculacao = null
      },

      async enviarVinculacoesTJ () {
        loader({ text: 'Aguarde...', active: true })

        const data = {
          numSeloVinculador: this.enviarVinculacaoTJ.numSeloVinculador,
          dataVinculacao: moment(this.enviarVinculacaoTJ.dataVinculacao).format('YYYY-MM-DD HH:mm:ss')
        }

        try {
          const { vinculacoes } = await SelosService.enviarVinculacoesPendentesTJ(data)

          this.$root.$emit('bv::hide::modal', `modalEnvioTJ_${this._uid}`)

          loader({ text: '', active: false })

          let texto = 'Envio realizado com sucesso!'

          const vinculacoesComErro = vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)

          if (vinculacoesComErro.length) {
            texto = vinculacoesComErro.length === 1 ? 'Ocorreu erro alguma vinculação. ' : 'Ocorreu erro com algumas vinculações. '
            texto += 'Para verificar localize a data da vinculações na lista de selos vinculados e clique em editar para mais informações.'
          }

          objSwal.info.title = ''
          objSwal.info.text = texto
          objSwal.info.html = ''

          await Swal.fire(objSwal.info).then(() => {
            this.selosVinculados = []
            this.vinculacoes = []
            this.getSelos()
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        } catch (e) {
          loader({ text: '', active: false })

          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível enviar as vinculações'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        } finally {
          // voltamos as variáveis para fechar o modal
          this.modalEnviarVinculacaoTJ = false
          this.enviarVinculacaoTJ.numSeloVinculador = null
          this.enviarVinculacaoTJ.dataVinculacao = null
        }
      },
      verificarSelosHabilitacao (habilitacao) {
        if (habilitacao.registro && habilitacao.registro.selos && habilitacao.registro.selos.length) {
          let vinculado = false

          habilitacao.registro.selos.forEach(seloRegistro => {
            const selo = this.selosVinculados.find (selo => selo.seloVinculacao.num_selo === seloRegistro.num_selo)

            if (selo) vinculado = true
          })

          if (!vinculado) this.$emit('vincularHabilitacao', habilitacao)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .BoxVinculacao {
    box-shadow: 0 0 pxToRem(6) $color-dark;
    
    &_header {
      font-size: 18px;
      font-weight: 500;

      &_box {
        font-size: pxToRem(15);
        font-weight: 500;

        &_selo_vinculador {
          max-width: pxToRem(225)
        }

        &_data_vinculacao {
          max-width: pxToRem(150)
        }

        &_status {
          max-width: pxToRem(120);
        }

        &_text,
        &_info {
          display: inline-block;
          line-height: pxToRem(14);
          width: 100%;
        }

        &_border_dark_top {
          border-top: pxToRem(1) solid $color-dark;
        }
      }

      &_color {
        background-color: rgba(38, 38, 38, 0.2);
        color: $color-dark;
      }

      &_font_status {
        font-size: pxToRem(15);
      }
    }

    &_openDetails {
      background-color: rgba($color-dark, 0.2);
      border: none;
      cursor: pointer;
      bottom: 0;
      left: 0;
      max-height: pxToRem(20);
      right: 0;
      transition: background-color 0.15s linear;

      &_icon {
        outline: none;
        vertical-align: baseline;
      }

      &:hover,
      &:focus {
        background-color: rgba($color-dark, 0.4);
        outline: none;

        .BoxVinculacao_openDetails_icon {
          fill: $color-white;
          transition: transform 0.15s linear;
        }
      }
    }
    
    &_detailsBoxInfo {
      &_title,
      &_text {
        font-size: pxToRem(15);
        margin-bottom: pxToRem(4);
      }

      &_title {
        border-bottom: pxToRem(1) solid;
        display: inline-block;
      }

      &_line_height {
        line-height: 1.7;
      }
    }

    &_rodate_button {
      transform: rotate(180deg);
    }
  }

  .SelosVinculados {
    &_header {
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(8);
      background-color: #f0ecec;
      line-height: 35px;
    }

    &_title {
      font-size: pxToRem(17) !important;
      font-weight: 500;
    }
  }

  .Listagem {
    width: 100%;
    font-size: pxToRem(14);
    
    &_width_selo_vinculado {
      width: 25%;
    }
   
    &_width_descricao {
      width: 75%;
    }

    &_border_bottom {
      border-bottom: 1px dashed rgba(38, 38, 38, 0.4);
    }
  }

  .EnvioTJ {
    &_titulo {
      font-size: 17.5px;
    }

    &_botao-voltar {
      background-color: #c8c4c4;
    }
  }
</style>
